import { useMemo } from 'react';
import { PayloadStates } from '@lore/utils';
import useTags from '@/hooks/useTags';
import TagTypes from '@/constants/TagTypes';
import { INTENT_TAG_NAMES } from '@/features/videos-common/audiences';

/**
 * The tag ids of the Educator and Partner Intent tags, which is what
 * StaffVideoInput.audiences expects. Uses the app's cached tag list.
 *
 * @returns {{ ids: Object<string, number>, isLoading: boolean }}
 *   ids is keyed by tag name, e.g. { Educator: 574, Partner: 575 }
 */
export default function useIntentTagIds() {
  const tags = useTags(TagTypes.Intent);
  const isLoading = tags.state === PayloadStates.FETCHING;

  const ids = useMemo(() => {
    const result = {};
    (tags.data || []).forEach((tag) => {
      const name = tag?.data?.name;
      if (INTENT_TAG_NAMES.includes(name) && Number.isInteger(tag.id)) result[name] = tag.id;
    });
    return result;
  }, [tags.data]);

  return { ids, isLoading };
}
